/* Ajax API */


if ((typeof Helpers) === 'undefined') {
  Helpers = {};
}

// -------------------------------------------------------------------------------------
// POST to cart/add.js returns the JSON of the line item associated with the added item.
// -------------------------------------------------------------------------------------
Helpers.addItem = function(variant_id, quantity, callback) {
  var quantity = quantity || 1;
  var params = {
    type: 'POST',
    url: '/cart/add.js',
    data: 'quantity=' + quantity + '&id=' + variant_id,
    dataType: 'json',
    success: function(line_item) {
      if ((typeof callback) === 'function') {
        callback(line_item);
      }
      else {
        Helpers.onItemAdded(line_item);
      }
    },
    error: function(XMLHttpRequest, textStatus) {
      Helpers.onError(XMLHttpRequest, textStatus);
    }
  };
  jQuery.ajax(params);
};


// ---------------------------------------------------------
// POST to cart/change.js returns the cart in JSON.
// ---------------------------------------------------------
Helpers.removeItem = function(variant_id, callback) {
  var params = {
    type: 'POST',
    url: '/cart/change.js',
    data:  'quantity=0&id='+variant_id,
    dataType: 'json',
    success: function(cart) {
      if ((typeof callback) === 'function') {
        callback(cart);
      }
      else {
        Helpers.onCartUpdate(cart);
      }
    },
    error: function(XMLHttpRequest, textStatus) {
      Helpers.onError(XMLHttpRequest, textStatus);
    }
  };
  jQuery.ajax(params);
};

Helpers.onCartUpdate = function(cart) {
  console.log('There are now ' + cart.item_count + ' items in the cart.');
};

Helpers.onItemAdded = function(line_item) {
  console.log(line_item.title + ' was added to your shopping cart.');
};

Helpers.onError = function(XMLHttpRequest, textStatus) {
  // Helpers returns a description of the error in XMLHttpRequest.responseText.
  // It is JSON.
  // Example: {"description":"The product 'Amelia - Small' is already sold out.","status":500,"message":"Cart Error"}
  var data = eval('(' + XMLHttpRequest.responseText + ')');
  if (!!data.message) {
    console.log(data.message + '(' + data.status  + '): ' + data.description);
  } else {
    console.log('Error : ' + Helpers.fullMessagesFromErrors(data).join('; ') + '.');
  }
};

Helpers.fullMessagesFromErrors = function(errors) {
  var fullMessages = [];
  jQuery.each(errors, function(attribute, messages) {
    jQuery.each(messages, function(index, message) {
      fullMessages.push(attribute + ' ' + message);
    });
  });
  return fullMessages
}
